<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">New roles</span>
        </v-card-title>
        <v-card-text>
          <v-col cols="12">
            <v-text-field
              label="name*"
              placeholder="Name..."
              :rules="[isNameValid || 'This field is required, and must contain 3 letters at least']"
              outlined
              v-model="name"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-textarea
              label="description"
              placeholder="Description..."
              outlined
              v-model="description"
            ></v-textarea>
          </v-col>
          <small>*indicates required field</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="cancel">Close</v-btn>
          <v-btn color="blue darken-1" text @click="save" :disabled="!isNameValid">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="isLoading" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Please stand by
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: { dialog: { type: Boolean, required: true } },
  data() {
    return {
      name: "",
      description: ""
    };
  },
  computed: {
    ...mapState({
      isLoading: state => state.roles.createOne.pending
    }),
    isNameValid() {
      return this.name.length >= 3;
    }
  },
  methods: {
    reset() {
      this.name = "";
      this.description = "";
    },
    cancel() {
      this.$emit("cancel");
      this.reset();
    },
    save() {
      this.$emit("save", this.name, this.description);
    }
  }
};
</script>